import React from 'react'
import { WithSearchList } from '$common/with-search-list'
import {
  VirtualizedList,
  virtualizedListDefaultProps,
} from '$common/virtualized-list'
import { SearchableListProps } from './searchable-list.types'

export function SearchableList<Item, SearchParams>({
  items,
  itemSize,
  searchQuery,
  searchHook,
  searchHookParams,
  loading,
  ...commonProps
}: SearchableListProps<Item, SearchParams>) {
  return (
    <WithSearchList
      {...commonProps}
      hasSearchQuery={!!searchQuery}
      searchHook={searchHook}
      searchHookParams={searchHookParams}
    >
      <VirtualizedList
        {...commonProps}
        items={items}
        itemSize={itemSize}
        loading={loading}
      />
    </WithSearchList>
  )
}

SearchableList.defaultProps = virtualizedListDefaultProps
